import React, { createContext, useState, useContext, useRef } from "react";

const VideoContext = createContext<any>(null);

export const VideoProvider = ({ children }: { children: React.ReactNode }) => {
  const [open, setOpen] = useState(false);
  const [isPiP, setIsPiP] = useState(false);
  const [videoId, setVideoId] = useState("");
  const [youtubeTitle, setYoutubetitle] = useState("");
  const [options, setOptions] = useState<any>({});
  const [isLiked, setIsLiked] = useState(false);
  const [likedMsg, setLikedMsg] = useState(null);
  const [gitasevalogo, setGitasevalogo] = useState("");
  const [playbackTime, setPlaybackTime] = useState(0);
  const [videoObjId, setVideoObjId] = useState<any>();
  const [playingVideo,setPlayingVideo]=useState<boolean>(false);
  type MediaType = 'none' | 'audio' | 'video';
  const [activeMedia, setActiveMedia] = useState<MediaType>('none');
    const refVideo:any=useRef(null);

      const playerRef = useRef(null); // YouTube वीडियो प्लेयर के लिए
  const audioPlayerRef = useRef(null); // HTML <audio> एलिमेंट के लिए
  // const{refAudio}=useAudio()
    const refAudio = useRef<any>(null);
    

    
  return (
    <VideoContext.Provider
      value={{
        open,
        setOpen,
        isPiP,
        setIsPiP,
        videoId,
        setVideoId,
        youtubeTitle,
        setYoutubetitle,
        options,
        setOptions,
        isLiked,
        setIsLiked,
        likedMsg,
        setLikedMsg,
        gitasevalogo,
        setGitasevalogo,
        playbackTime,
        setPlaybackTime,
        videoObjId,
        setVideoObjId,
        refVideo,
        playingVideo,
        setPlayingVideo,
        activeMedia,
        setActiveMedia,
        playerRef,
        audioPlayerRef
      }}
    >
      {children}
    </VideoContext.Provider>
  );
};

export const useVideo = () => useContext(VideoContext);
